/**
 * Campos e pesquisas prontas da tela de Pesquisa de Processos.
 *
 * A nomenclatura acompanha `PesquisaAvancadaProcesso.jsx` e
 * `PesquisaEspecialProcesso.jsx` do abe-web-react — no código real as
 * "pesquisas prontas" já existem com o nome "Pesquisas Especiais".
 */

/** Campos da pesquisa simples (sempre visíveis) — espelha `pesquisa_check3.png`. */
export const CAMPOS_SIMPLES = [
  {
    id: 'nroProcesso', label: 'Processo:', tipo: 'texto', col: 1,
  },
  {
    id: 'abertosEntre', label: 'Abertos entre:', tipo: 'periodo', col: 2,
  },
  {
    id: 'cnpjCpfDevedor', label: 'CNPJ/CPF Devedor', tipo: 'texto', col: 1,
  },
  {
    id: 'cidadeDevedor', label: 'Cidade do Devedor:', tipo: 'texto', col: 2,
  },
  {
    id: 'uf', label: 'UF', tipo: 'select', col: 2, largura: 'pequena', options: ['SP', 'RJ', 'MG', 'PR', 'RS', 'SC', 'BA', 'GO', 'ES'],
  },
  {
    id: 'nomeDevedor', label: 'Nome devedor:', tipo: 'texto', col: 1,
  },
  {
    id: 'recebidosEntre', label: 'Recebidos entre:', tipo: 'periodo', col: 2,
  },
  {
    id: 'codigoCliente', label: 'Código do cliente:', tipo: 'texto', col: 1,
  },
  {
    id: 'paraODia', label: 'Para o dia:', tipo: 'data', col: 2,
  },
  {
    id: 'nomeCliente', label: 'Nome Cliente:', tipo: 'select', col: 1, largura: 'grande', options: ['Cliente Teste - Sprint 34', 'Cliente Fictício para Testes', 'Distribuidora Norte'],
  },
];

/** Segundo bloco, também sempre visível. */
export const CAMPOS_COMPLEMENTARES = [
  {
    id: 'pasta', label: 'Pasta:', tipo: 'select', col: 1, options: ['Pasta 04', 'Pasta 07', 'Pasta 12'],
  },
  {
    id: 'negociador', label: 'Negociador:', tipo: 'select', col: 2, options: ['Murilo Andrade', 'Maomao Silva', 'Débora Thomaz Martins', 'Carlos Henrique Lima', 'Gabriela do Nascimento Pereira'],
  },
  {
    id: 'agendamento', label: 'Agendamento:', tipo: 'select', col: 1, options: ['Ligar para o devedor', 'Notificação E-mail', 'Visita ao Devedor', 'Retorno'],
  },
  {
    id: 'status', label: 'Status:', tipo: 'select', col: 2, options: ['Ativo', 'Unificado', 'Incobrável', 'Recebido', 'Ajuizado'],
  },
  {
    id: 'codigoDevedor', label: 'Código do Devedor:', tipo: 'texto', col: 1,
  },
  {
    id: 'fase', label: 'Fase:', tipo: 'select', col: 2, options: ['Auditoria', 'Pós Auditoria', 'NT', 'Jurídico', 'Adv. Externo'],
  },
];

/**
 * Campos que só aparecem ao acionar "PESQUISA AVANÇADA".
 * Exatamente os 4 itens pedidos (o último é um período com duas datas).
 */
export const CAMPOS_AVANCADOS = [
  {
    id: 'cpfCnpjCliente', label: 'CPF/CNPJ Cliente', tipo: 'texto', col: 1,
  },
  {
    id: 'estadoDevedor', label: 'Estado do Devedor', tipo: 'select', col: 2, options: ['SP', 'RJ', 'MG', 'PR', 'RS', 'SC', 'BA', 'GO', 'ES'],
  },
  {
    id: 'dataAgendamento', label: 'Data do Agendamento', tipo: 'data', col: 1,
  },
  {
    id: 'periodoEnvioFase', label: 'Período de envio para fase atual', tipo: 'periodo', col: 2,
  },
];

/**
 * Pesquisas prontas. `params` descreve os campos condicionais que aparecem
 * quando o item é marcado.
 */
export const PESQUISAS_PRONTAS = [
  { id: 'meusProcessos', label: 'Meus Processos', params: [] },
  {
    id: 'acordosVencidos',
    label: 'Processos com Acordos vencidos no período',
    params: [
      {
        id: 'negociador', label: 'Negociador', tipo: 'select', options: ['Murilo Andrade', 'Maomao Silva', 'Débora Thomaz Martins'],
      },
      { id: 'periodo', label: 'Período', tipo: 'periodo' },
    ],
  },
  {
    id: 'ultimaParcelaQuitada',
    label: 'Processos com a última parcela quitada no período',
    params: [{ id: 'periodo', label: 'Período', tipo: 'periodo' }],
  },
  { id: 'minhasRequisicoes', label: 'Minhas Requisições', params: [] },
  {
    id: 'naoTrabalhados',
    label: 'Processos não trabalhados',
    params: [
      {
        id: 'fase', label: 'Fase', tipo: 'select', options: ['Auditoria', 'Pós Auditoria', 'NT', 'Jurídico'],
      },
      {
        id: 'negociador', label: 'Negociador', tipo: 'select', options: ['Murilo Andrade', 'Maomao Silva', 'Débora Thomaz Martins'],
      },
    ],
  },
  {
    id: 'expirados',
    label: 'Processos Expirados ou a Expirar',
    params: [{ id: 'codCliente', label: 'Cód. Cliente', tipo: 'texto' }],
  },
  { id: 'titulosNaoVencidos', label: 'Processos somente com Títulos não vencidos', params: [] },
  { id: 'ajuizados', label: 'Processos Ajuizados', params: [] },
  {
    id: 'devedorEspecifico',
    label: 'Processos de um Devedor Específico',
    params: [
      { id: 'cpfCnpjDevedor', label: 'CPF/CNPJ do Devedor', tipo: 'texto' },
      { id: 'nomeDevedor', label: 'Nome do Devedor', tipo: 'texto' },
    ],
  },
  {
    id: 'prazoNoPeriodo',
    label: 'Processos com Prazo em um período',
    params: [
      {
        id: 'tipoAgendamento', label: 'Tipo de Agendamento', tipo: 'select', options: ['Ligar para o devedor', 'Notificação E-mail', 'Visita ao Devedor', 'Retorno', 'Jurídico'],
      },
      { id: 'periodoAgendamento', label: 'Período de Agendamento', tipo: 'periodo' },
    ],
  },
];

/** Cards "Minhas informações" do rodapé da tela de pesquisa. */
export const MINHAS_INFORMACOES = [
  { id: 'meusProcessos', label: 'Meus Processos', total: 12 },
  { id: 'naoTrabalhados', label: 'Processos não trabalhados', total: 6 },
  { id: 'promessasBoletos', label: 'Promessas de boletos', total: 3 },
  { id: 'acordosNaoCumpridos', label: 'Acordos não cumpridos', total: 4 },
  { id: 'prazos', label: 'Prazos', total: 9 },
  { id: 'promessasRetorno', label: 'Promessas de retorno', total: 2 },
];
